import { DarkModeValue } from 'redhotpie-shared-lib/types/theme';
import { FONT_SIZES, THEMES } from '../constants/constants';

class MessengerTheme {
  darkMode: boolean;
  themeType: string;
  fontSize: string;
  darkModeSetting: DarkModeValue;
  constructor() {
    this.darkMode = false;
    this.themeType = THEMES.GREEN;
    this.fontSize = FONT_SIZES.REGULAR;
    this.darkModeSetting = 'Off'; // On - Off - Default
  }

  static mappingObject(_o: any): MessengerTheme {
    const result = new MessengerTheme();
    if (_o) {
      result.darkMode = _o.DarkMode;
      result.themeType = _o.ThemeType;
      result.fontSize = _o.FontSize;
      result.darkModeSetting = _o.DarkModeSetting;
    }
    return result;
  }
}

export default MessengerTheme;
